import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Icon } from "semantic-ui-react";
import axios from "axios";

export default function FindContractById() {
  const [error, setError] = useState(null);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [resultId, setResultId] = useState(null);

  const CancelToken = axios.CancelToken;
  const cancelRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, [value]);

  function fetchData() {
    setError(null);
    setResultId(null);

    if (!value) return;

    setLoading(true);

    const cancel = cancelRef.current;
    if (cancel) {
      cancel();
    }

    axios
      .get(`/contracts/${value}/`, {
        cancelToken: new CancelToken(function executor(c) {
          cancelRef.current = c;
        }),
      })
      .then(({ data }) => {
        setLoading(false);
        setResultId(data.id);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response.data.ui_message);
      });
  }

  return (
    <div>
      <Form>
        <Form.Input
          width={5}
          label="Find by Contract #"
          value={value}
          placeholder="Contract #"
          onChange={(e) => setValue(e.target.value)}
          icon="search"
          loading={loading}
        />
      </Form>
      {error && (
        <p style={{ margin: "10px 0 0 0" }}>
          <Icon name="ban" color="red" /> {error}
        </p>
      )}
      {resultId && (
        <p style={{ margin: "10px 0 0 0" }}>
          <Button
            size="mini"
            basic
            icon="eye"
            as={Link}
            to={`/dealer/contracts/${resultId}`}
          />{" "}
          View Contract
        </p>
      )}
    </div>
  );
}
